import { Component, inject, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DefaultComponent } from "@kpx/core";
import { ServicesDialogComponent } from "./services-dialog/services-dialog.component";

@Component({
  selector: "app-services-unavailable",
  imports: [],
  templateUrl: "./services-unavailable.component.html",
  styleUrl: "./services-unavailable.component.less",
})
export class ServicesUnavailableComponent extends DefaultComponent implements OnInit {
  private dialog: MatDialog;

  public constructor() {
    super();
    this.dialog = inject(MatDialog);
  }

  public ngOnInit(): void {
    this.dialog.open(ServicesDialogComponent, {
      data: {},
    });
  }
}
